import { render, staticRenderFns } from "./logReiDtl.vue?vue&type=template&id=36b31210&scoped=true&"
import script from "./logReiDtl.vue?vue&type=script&lang=js&"
export * from "./logReiDtl.vue?vue&type=script&lang=js&"
import style0 from "./logReiDtl.vue?vue&type=style&index=0&id=36b31210&prod&lang=scss&scoped=true&"
import style1 from "./logReiDtl.vue?vue&type=style&index=1&id=36b31210&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b31210",
  null
  
)

export default component.exports